/**
 * Corte do texto dos cards da história (SHO-15).
 *
 * Quem decide se corta é o navegador, medindo transbordo — não uma contagem de
 * caracteres. O app corta acima de 260 caracteres porque a tela dele tem ~358px;
 * na coluna de 522px do desktop, 260 caracteres cabem em três linhas, e o botão
 * aparecia em texto que já estava inteiro.
 *
 * Sem JavaScript o texto sai inteiro e o botão nunca aparece.
 */
class StealsStoryText extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector("[data-story-body]");
    this.button = this.querySelector("[data-story-toggle]");
    if (!this.body || !this.button) return;

    this.userToggled = false;
    this.button.addEventListener("click", () => this.toggle());
    this.measure();

    // A coluna muda de largura entre breakpoints, e com ela o número de linhas.
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.body);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  /** Depois que a pessoa mexeu, a decisão é dela — não medimos mais. */
  measure() {
    if (this.userToggled) return;

    this.classList.add("is-collapsed");
    const transborda = this.body.scrollHeight > this.body.clientHeight + 1;

    this.classList.toggle("is-collapsed", transborda);
    this.button.hidden = !transborda;
  }

  toggle() {
    this.userToggled = true;
    const colapsado = this.classList.toggle("is-collapsed");
    this.button.setAttribute("aria-expanded", String(!colapsado));
    this.button.textContent = colapsado
      ? this.button.dataset.more
      : this.button.dataset.less;
  }
}

customElements.define("steals-story-text", StealsStoryText);
